import { checkWithMediumJson } from './checkWithMediumJson';

/**
 * ตรวจสอบค่า ALP โดยใช้ค่าปกติจาก medium.json
 */
export default async (value, age, gender) => {
  return await checkWithMediumJson(value, 'ALP', gender, age, 'ALP');
};
